import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as auth from './reducers/auth.reducer';
import * as project from './reducers/project.reducer';
import * as job from './reducers/job.reducer';
import * as studio from './reducers/studio.reducer';
import * as team from './reducers/team.reducer';
import * as offer from './reducers/offer.reducer';
import * as documentSegment from './reducers/documentSegment.reducer';
import * as product from './reducers/product.reducer';
import * as media from './reducers/media.reducer';
import * as notification from './reducers/notification.reducer';
import * as report from './reducers/report.reducer';

export interface AppState {
  authState: auth.State;
  projectState : project.State;
  jobState : job.State;
  studioState : studio.State;
  teamState: team.State;
  offerState: offer.State;
  documentSegment: documentSegment.State;
  product: product.State;
  media: media.State;
  report: report.State;
  //notification: notification.State;
}

export const reducers = {
  auth: auth.reducer,
  project : project.reducer,
  job : job.reducer,
  studio : studio.reducer,
  team : team.reducer,
  offer : offer.reducer,
  documentSegment : documentSegment.reducer,
  product : product.reducer,
  media : media.reducer,
  notification : notification.reducer,
  report : report.reducer,
};

export const selectAuthState = createFeatureSelector<AppState>('auth');
export const selectProjectState = createFeatureSelector<AppState>('project');
export const selectJobState = createFeatureSelector<AppState>('job');
export const selectStudioState = createFeatureSelector<AppState>('studio');
export const selectTeamState = createFeatureSelector<AppState>('team');
export const selectOfferState = createFeatureSelector<AppState>('offer');
export const selectDocumentSegmentState = createFeatureSelector<AppState>('documentSegment');
export const selectProductState = createFeatureSelector<AppState>('product');
export const selectMediaState = createFeatureSelector<AppState>('media');
export const selectNotificationState = createFeatureSelector<AppState>('notification');
export const selectReportState = createFeatureSelector<AppState>('report');

/*export const selectProjectState = createSelector(
  selectAuthState,
  (state: AppState) => state.projectState
);*/
//export const selectProjectState = createFeatureSelector<AppState>('project');



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/app.states.ts